// Libellés des tickets de support. Les valeurs correspondent exactement aux enums
// TicketCategory / TicketStatus du backend (app/enums.py) : elles transitent en
// clair dans l'API et servent de clés de filtrage, il ne faut pas les traduire
// côté serveur.

export const TICKET_CATEGORIES = [
  { value: 'question', label: 'Question' },
  { value: 'bug', label: 'Problème technique' },
  { value: 'donnees', label: 'Mes données (accès, rectification)' },
  { value: 'suppression_compte', label: 'Suppression de mon compte' },
  { value: 'autre', label: 'Autre' },
];

export const TICKET_CATEGORY_LABELS = Object.fromEntries(
  TICKET_CATEGORIES.map((c) => [c.value, c.label]),
);

export const TICKET_STATUS_LABELS = {
  ouvert: 'Ouvert',
  en_cours: 'En cours',
  resolu: 'Résolu',
  clos: 'Clos',
};

//: Un ticket clos n'accepte plus de message — le backend renvoie 409.
export const isTicketClosed = (statut) => statut === 'clos';

export const formatTicketDate = (value) =>
  value ? new Date(value).toLocaleDateString('fr-FR', {
    day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
  }) : '—';
